const appName = 'Kitsugi';
const gDrive = 'Диск';

export default {
    admin_info: 'Информация',
    admin_total_users: 'Всего пользователей',
    admin_total_sessions: 'Всего сессий',
    admin_total_clients: 'Всего клиентов',
    admin_users: 'Список пользователей',
    admin_sessions: 'Сессии',
    admin_logs: 'Логи',
    admin_create_user: 'Создать пользователя',
    admin_create: 'Создать',
    admin_fill_required: 'Заполните обязательные поля',
    admin_fill_all_fields: 'Необходимо заполнить все поля: Email, Пароль и Имя',

    admin_user_logs: 'Логи пользователя',
    admin_no_logs: 'Логи отсутствуют',
    admin_all_sessions: 'Все сессии',
    admin_clients: 'Клиенты',
    admin_user_clients: 'Клиенты пользователя',
    admin_client_name: 'Имя',

    admin_create_error: 'Ошибка при создании пользователя',
    admin_create_success: 'Пользователь создан успешно',
    admin_invalid_email: 'Пожалуйста, введите корректный email',
    admin_password_too_short: 'Пароль должен содержать минимум 6 символов',
    admin_tab_info: 'Информация',
    admin_tab_users: 'Список пользователей',
    admin_tab_create: 'Создать',
    admin_tab_reports: 'Репорты',
    
    // Desktop and navigation
    desktop_title: 'Рабочий стол',
    
    // Admin panel translations
    'admin_loading_reports': 'Загрузка отчетов...',
    'admin_reports_count': 'Отчеты',
    'admin_no_reports': 'Отчеты не найдены',
    'admin_report_open': 'Открыть',
    'admin_report_delete': 'Удалить',
    'admin_all_time': 'Все время',
    'admin_last_week': 'Последняя неделя',
    'admin_last_month': 'Последний месяц',
    'admin_last_year': 'Последний год',
    'admin_dataset_all': 'Все',
    'admin_dataset_users': 'Пользователи',
    'admin_dataset_sessions': 'Сессии',
    'admin_dataset_clients': 'Клиенты',
    'admin_loading_sessions': 'Загрузка сессий...',
    'admin_no_sessions': 'Нет доступных сессий',
    'admin_show_json': 'Показать JSON',
    'admin_hide_json': 'Скрыть JSON',
    'admin_loading_clients': 'Загрузка клиентов...',
    'admin_no_clients': 'Нет доступных клиентов',
    'admin_client_sessions': 'Сессии клиента',
    'admin_no_client_sessions': 'Нет доступных сессий для этого клиента.',
    'admin_session_id': 'ID',
    'admin_prediction_id': 'ID предсказания',
    'admin_date': 'Дата',
    'admin_client_id': 'ID клиента',
    'admin_title': 'Название',
    'admin_status': 'Статус',
    'admin_date_to': 'Дата до',
    admin_email: "Email",
    admin_password: "Пароль",
    admin_first_name: "Имя",
    admin_last_name: "Фамилия",
    admin_disable_user: "Отключить",
    admin_enable_user: "Включить",

    common_firstName: "Имя",
    common_lastName: "Фамилия", 
    common_save: "Сохранить",
    common_saving: "Сохранение...",
    common_delete: "Удалить",
    common_reset: "Сбросить",
    common_create: "Создать",

    sideMenu_profile: "Мой профиль",
    sideMenu_privacy: "Конфиденциальность и безопасность",
    sideMenu_language: "Язык",
    sideMenu_quickstart: "Быстрый старт",
    quickstart_content_welcome: "🚀 Быстрый старт: начните работать с клиентами и анализами",
    quickstart_content_descr: "Эта краткая инструкция поможет вам сделать первые шаги и максимально использовать возможности сервиса.",
    quickstart_content_1: "Создайте своего первого клиента",
    quickstart_content_1_text:`Переключите боковое меню на раздел «Клиенты» — кнопка находится в левом нижнем углу экрана, слева от вашего аватара. Иконка — группа людей.

Откроется меню со списком клиентов. Пока здесь пусто, но скоро появится список всех ваших клиентов.

Чтобы добавить клиента, нажмите кнопку «плюс» справа от поисковой строки вверху меню.
Заполните необходимые поля и нажмите «Создать».`,
    quickstart_content_2: "Начните работу с клиентом",
    quickstart_content_2_text:`Кликните по клиенту в списке.
Справа откроется меню с четырьмя вкладками:

Сессии — список всех запланированных и проведённых встреч.

Календарь — ваш планировщик: можно создавать новые сессии или добавлять другие события и задачи.

Жизненные события — здесь будут собираться события, которые клиент упоминал во время сессий.

Анализ — подробная аналитика по клиенту на основе всех проведённых сессий.`,
    quickstart_content_3: "Создайте первую сессию",
    quickstart_content_3_text:`Перейдите во вкладку «Сессии».

Внизу справа нажмите кнопку с плюсиком — откроется меню создания сессии.

Можно указать повторение сессии — так вы сразу создадите серию связанных встреч для удобного редактирования в будущем.`,
    quickstart_content_4:"Загрузите запись и получите анализ",
    quickstart_content_4_text:`
После создания сессия появится в списке сессий.

В правой части элемента сессии будет кнопка «Загрузить» — используйте её, чтобы прикрепить видео или аудиозапись.

После загрузки записи системе потребуется немного времени для анализа.
Когда анализ будет готов, вместо кнопки «Загрузить» появится кнопка «Смотреть» — нажмите её, чтобы увидеть подробный разбор сессии.`,
    quickstart_done: "🎉 Готово!",
    quickstart_done_descr: `
Теперь вы знаете, с чего начать.
Создайте клиентов, планируйте сессии и получайте ценный анализ — ваш помощник всегда под рукой!`,
    sideMenu_faq: "FAQ",

    faq_general_title: "Общие вопросы",
    faq_general_q1: "Что это за сервис и чем он может помочь мне как психологу?",
    faq_general_a1: "Наш сервис помогает психологам и психотерапевтам вести список клиентов, планировать сессии, хранить записи встреч и автоматически анализировать их содержание — чтобы вы могли лучше отслеживать прогресс и динамику.",
    faq_general_q2: "Нужно ли устанавливать какое-то приложение?",
    faq_general_a2: "Нет! Вы работаете через браузер на любом устройстве — все ваши данные хранятся в защищённом облаке.",

    faq_clients_title: "Клиенты и профили",
    faq_clients_q1: "Как добавить нового клиента?",
    faq_clients_a1: "Перейдите в раздел «Клиенты», нажмите на значок «плюс» в верхней части меню и заполните необходимые данные.",
    faq_clients_q2: "Можно ли редактировать данные клиента?",
    faq_clients_a2: "Да! Просто выберите клиента из списка и отредактируйте нужные поля. Все изменения сохраняются автоматически.",

    faq_sessions_title: "Сессии и записи",
    faq_sessions_q1: "Как создать сессию?",
    faq_sessions_a1: "Зайдите во вкладку «Сессии» у выбранного клиента и нажмите кнопку «плюс» — вы можете указать дату, время, а также настроить повторение, если встреча регулярная.",
    faq_sessions_q2: "Как загрузить запись сессии?",
    faq_sessions_a2: "После создания сессии нажмите кнопку «Загрузить» справа от названия. Поддерживаются видео- и аудиофайлы.",
    faq_sessions_q3: "Сколько времени занимает анализ записи?",
    faq_sessions_a3: "Обычно анализ занимает от нескольких минут до часа, в зависимости от длины записи. Вы сможете просмотреть анализ сразу после обработки.",

    faq_analysis_title: "Анализ и конфиденциальность",
    faq_analysis_q1: "Кто может видеть мои записи и анализ?",
    faq_analysis_a1: "Доступ к этой информации есть только у вас и администрации.",
    faq_analysis_q2: "Можно ли скачать запись сессии потом?",
    faq_analysis_a2: "Да! Вы можете сохранить запись потом, если потребуется.",

    faq_support_title: "Техническая поддержка",
    faq_support_q1: "Что делать, если у меня возник вопрос?",
    faq_support_a1: "Вы всегда можете обратиться в нашу службу поддержки через чат или по email. Мы ответим вам в течение рабочего дня. Также вы можете связаться со своим куратором по любому вопросу.",
    faq_support_q2: "Что делать, если не загружается видео или возникают ошибки?",
    faq_support_a2: "Проверьте стабильность интернет-соединения. Если проблема повторяется, напишите в поддержку — мы поможем!",
    faq_support_q3: "Как быстро отправить сообщение об ошибке или предложении?",
    faq_support_a3: "Используйте горячую клавишу Ctrl+/ для быстрой отправки сообщения об ошибке или предложении. Это самый удобный способ связаться с технической поддержкой.",
    sideMenu_settings: "Настройки",
    sideMenu_help: "Помощь",
    sideMenu_administrator: "Администрация",
    sideMenu_logout: "Выход",

    sideMenuSettings_fontSize: "Размер шрифта",
    sideMenuSettings_timezone: "Часовой пояс",
    sideMenuSettings_timezoneAuto: "(автоматически)",

    // Timezone names (UTC-12 to UTC+14)
    timezone_gmt_minus_12: "GMT-12",
    timezone_pago_pago: "Паго-Паго",
    timezone_honolulu: "Гонолулу",
    timezone_anchorage: "Анкоридж",
    timezone_los_angeles: "Лос-Анджелес",
    timezone_denver: "Денвер",
    timezone_chicago: "Чикаго",
    timezone_new_york: "Нью-Йорк",
    timezone_caracas: "Каракас",
    timezone_sao_paulo: "Сан-Паулу",
    timezone_noronha: "Норонья",
    timezone_azores: "Азоры",
    timezone_london: "Лондон",
    timezone_paris: "Париж",
    timezone_kiev: "Киев",
    timezone_moscow: "Москва",
    timezone_dubai: "Дубай",
    timezone_karachi: "Карачи",
    timezone_dhaka: "Дакка",
    timezone_bangkok: "Бангкок",
    timezone_shanghai: "Шанхай",
    timezone_tokyo: "Токио",
    timezone_sydney: "Сидней",
    timezone_noumea: "Нумеа",
    timezone_auckland: "Окленд",
    timezone_tongatapu: "Нукуалофа",
    timezone_kiritimati: "Киритимати",

    sideMenuPrivacy_updatePassword: "Изменить пароль",
    sideMenuPrivacy_oldPassword: "Текущий пароль",
    sideMenuPrivacy_newPassword: "Новый пароль",
    sideMenuPrivacy_changePassword: "Сменить пароль",

    bottomMenu_Sessions: 'Сессии',
    bottomMenu_Notes: "Заметки",
    bottomMenu_Chat: 'Чат',
    bottomMenu_Calendar: 'Календарь',
    bottomMenu_Lifeline: 'Линия жизни',
    bottomMenu_Analysis: 'Анализ',
    bottomMenu_Statistic: 'Статистика',
    bottomMenu_Mindmap: 'Майндмап',
    mindmap_new_board: 'Новая доска',
    mindmap_delete: 'Удалить',
    mindmap_delete_confirm: 'Удалить эту доску?',
    mindmap_basic: 'Фигуры',
    mindmap_box: 'блок',
    mindmap_round: 'круг',
    mindmap_triangle: 'треугольник',
    mindmap_trapezoid: 'трапеция',
    mindmap_star: 'звезда',
    mindmap_sticker: 'стикер',
    mindmap_delete_block: 'Удалить',
    mindmap_delete_cancel: 'Отмена',
    mindmap_export: 'Экспорт JSON',
    mindmap_context_export: 'Экспорт',
    mindmap_context_delete: 'Удалить',
    mindmap_arrows: 'Стрелки',
    mindmap_arrow_thin: 'Тонкая стрелка',
    mindmap_arrow_thick: 'Толстая стрелка',
    mindmap_arrow_hollow: 'Полая стрелка',
    mindmap_arrows_manual: 'Ручные',
    mindmap_arrow_manual_thin: 'Ручная тонкая',
    mindmap_arrow_manual_thick: 'Ручная толстая',
    mindmap_arrow_manual_hollow: 'Ручная полая',
    mindmap_arrows_auto: 'Авто',
    mindmap_arrows_straight: 'Прямые',
    mindmap_arrow_straight_thin: 'Прямая тонкая',
    mindmap_arrow_straight_thick: 'Прямая толстая',
    mindmap_arrow_straight_hollow: 'Прямая полая',
    mindmap_arrows_block: 'С текстом',
    mindmap_arrow_block: 'Блочная стрелка с текстом',
    mindmap_arrow_hint: 'Выберите тип стрелки, затем нажмите на две оранжевые точки для соединения фигур',
    mindmap_manual_hint_line1: 'Сегмент: перетащить (Shift=свободно) | Точка: перетащить (Shift=выровнять)',
    mindmap_manual_hint_line2: 'Двойной клик: добавить точку | ПКМ: удалить',
    mindmap_center_camera: 'Центрировать всё',
    mindmap_undo: 'Отменить (Ctrl+Z)',
    mindmap_reset_zoom: 'Сбросить масштаб',
    mindmap_fullscreen: 'Полный экран',
    mindmap_exit_fullscreen: 'Выйти из полного экрана',
    mindmap_other: 'Другое',
    mindmap_text: 'Текст',
    mindmap_text_placeholder: 'Введите текст...',
    mindmap_media: 'Медиа',
    mindmap_add_media: 'Добавить медиа',
    mindmap_media_url: 'Ссылка',
    mindmap_media_url_placeholder: 'https://example.com/image.jpg',
    mindmap_upload_file: 'Загрузить файл',
    mindmap_or: 'или',
    mindmap_add: 'Добавить',
    mindmap_folders: 'Папки',
    mindmap_folders_filter_client: 'Только папки клиента',
    mindmap_folders_empty: 'Папки не найдены',
    mindmap_folders_no_subfolders: 'Нет подпапок',
    mindmap_folders_open: 'Открыть папку',
    mindmap_notes: 'Заметки',
    mindmap_notes_empty: 'Заметки не найдены',
    mindmap_untitled_note: 'Без названия',
    mindmap_tasks: 'Задачи',
    mindmap_tasks_filter_client: 'Только задачи клиента',
    mindmap_tasks_empty: 'Задачи не найдены',
    mindmap_untitled_task: 'Без названия',
    mindmap_draw: 'Рисовать',
    mindmap_draw_color: 'Цвет',
    mindmap_draw_width: 'Толщина',
    mindmap_settings: 'Настройки',
    mindmap_background_color: 'Фон',
    mindmap_background_type_color: 'Цвет',
    mindmap_background_type_cork: 'Доска',
    mindmap_show_dots: 'Показать точки',
    mindmap_fill: 'Заливка',
    mindmap_text_color: 'Цвет текста',
    mindmap_border: 'Граница',
    mindmap_show_all: 'Показать все',
    mindmap_show_client_only: 'Только для клиента',
    back: 'Назад',
    bottomMenu_lifeline: 'Линия жизни',

    'dashboard_page_title': 'Панель управления',

    // Notes Widget
    'notes_widget_title': 'Заметки',
    'notes_widget_view_all': 'Смотреть все заметки',
    'notes_widget_no_notes': 'Заметок пока нет',
    'notes_widget_create_first': 'Создать первую заметку',

    login_Appname: appName.toUpperCase(),
    login_LoginText: "Войти в "+appName,
    login_AllRightsText: "Все права защищены. "+appName,
    login_email: "Email адрес",
    login_password: "Пароль",
    login_remember_me: "Запомнить меня",
    login_forgot_password: "Забыли пароль?",
    login_proceed: "Продолжить",
    login_sign_up: "Регистрация",
    
    signup_title: "Создать аккаунт",
    signup_name: "Имя",
    signup_email: "Email адрес",
    signup_password: "Пароль",
    signup_repeat_password: "Повторите пароль",
    signup_remember_me: "Запомнить меня",
    signup_proceed: "Продолжить",
    signup_or: "или",
    signup_google: "Войти через Google",
    signup_login: "Вход",
    
    analysis_file_name: "Имя файла:",
    analysis_content: "Содержание анализа:",
    analysis_file_placeholder: "Введите имя файла (например, 'заметки-сессии')",
    analysis_content_placeholder: "Введите текст анализа здесь...",
    analysis_create_file: "Создать новый файл",
    analysis_append_to: "Добавить к",
    analysis_error_empty: "Пожалуйста, введите имя файла и содержание анализа",
    analysis_error_content: "Пожалуйста, введите содержание анализа для добавления",
    
    common_back: "Назад",
    common_user_avatar: "Аватар пользователя",
    common_report_screenshot: "Скриншот отчета",
    common_error_prefix: "Ошибка: ",

    gDrive: gDrive,
    desktop_uploadFile: 'Загрузить файл',
    desktop_uploadGDrive: `Добавить\u00A0файл\u00A0с\u00A0${gDrive}`,
    desktop_resetPositions: `Сбросить\u00A0позиции`,
    desktop_deleteFromGDrive: `Удалить\u00A0с\u00A0${gDrive}`,
    desktop_deleteSelectedFiles: (count: string | number)=>`Удалить\u00A0выделенные\u00A0${count}\u00A0файлов`,
    desktop_delete: (name: string)=>`Удалить\u00A0${name}`,
    desktop_addAnalysis: "Добавить анализ",
    desktop_createFolder: "Создать папку",
    desktop_rename: "Переименовать",
    desktop_moveFilesUp: "Переместить файлы вверх",
    desktop_options: "Параметры...",

    'Client': 'Клиент',
    'All clients': 'Все клиенты',
    'account_disabled': 'Аккаунт деактивирован',

    allTime: 'За все время',
    lastYear: 'За последний год',
    lastMonth: 'За последний месяц',
    lastWeek: 'За последнюю неделю',

    hotkeys_title: 'Горячие клавиши',
    hotkeys_general: 'Общие',
    hotkeys_navigation: 'Навигация',
    hotkeys_show_window: 'Показать это окно',
    hotkeys_close_modal: 'Закрыть модальное окно',
    hotkeys_save: 'Сохранить',
    hotkeys_undo: 'Отменить',
    hotkeys_message_placeholder: 'Введите ваше сообщение...',
    hotkeys_send_report: 'Отправить отчет',
    report_title: 'Отчет',
    'report.screenshot': 'Скриншот',
    'report.logs': 'Логи',
    'report.no_logs': 'Логи недоступны',
    'report.deleted': 'Репорт удален',
    'report.delete_error': 'Произошла ошибка',

    age_years_1: 'год',
    age_years_2_4: 'года',
    age_years_5_plus: 'лет',
    'events_without_dates': 'События без дат',
    'events': 'События',
    'lifeline_title': 'Линия жизни',
    'lifeline_add_event': 'Добавить событие',
    'lifeline_loading': 'Загрузка событий...',
    'lifeline_go_to_session': 'Перейти к сессии',
    'lifeline_no_events': 'События не найдены',
    'error_prefix': 'Ошибка:',
    'lifeline_create_error': 'Ошибка при создании события',
    'lifeline_event_type': 'Тип события',
    'lifeline_positive_event': 'Положительное событие',
    'lifeline_negative_event': 'Отрицательное событие',
    'lifeline_important_event': 'Важное событие',
    'lifeline_importance_level': 'Уровень важности',
    'lifeline_event_title': 'Событие',
    'lifeline_event_description': 'Описание',
    'lifeline_event_date': 'Дата события',
    'lifeline_save_event': 'Сохранить событие',
    'lifeline_cancel': 'Отменить',
    'lifeline_edit_event': 'Редактировать событие',
    'lifeline_delete_event': 'Удалить событие',
    'lifeline_save_changes': 'Сохранить изменения',
    'lifeline_loading_save': 'Сохранение...',
    'lifeline_error_save': 'Ошибка при сохранении',
    'lifeline_success_save': 'Событие сохранено',
    'lifeline_error_load': 'Ошибка при загрузке событий',
    'lifeline_error_delete': 'Ошибка при удалении события',
    'lifeline_confirm_delete': 'Вы уверены, что хотите удалить это событие?',
    'client_confirm_delete': 'Вы уверены, что хотите удалить этого клиента?',
    'lifeline_from_session_date': 'Из сессии [date]',
    'common_loading': 'Загрузка...',
    'common_error': 'Ошибка',
    'common_success': 'Успешно',
    'common_cancel': 'Отменить',
    'common_edit': 'Редактировать',
    'common_confirm': 'Подтвердить',
    'common_yes': 'Да',
    'common_no': 'Нет',
    'common_show_more': 'Показать больше',
    'common_show_less': 'Скрыть',
    'lifeline_show_all_events': 'Показать все события',
    'lifeline_hide_unimportant': 'Скрыть неважные события',
    'meeting_back': 'Вернуться',
    'no_client_selected': 'Клиент не выбран',
    'select_note_edit': 'Выберите заметку для редактирования или добавьте новую',
    'full_analysis_one_list': 'Один список',
    'full_analysis_one_list_desc': 'Показать все записи выбранного клиента как один файл анализа',
    'full_analysis_all_files': 'Все клиенты',
    'full_analysis_all_files_desc': 'Показать файлы всех клиентов',
    'clients_switch_clients': 'Клиенты',
    'clients_switch_schedule': 'Расписание',
    'search_clients_placeholder': 'Клиенты',
    'sideMenu_desktop': 'Рабочий стол',
    'sideMenu_startScreen': 'Стартовый экран',
    'day_sun': 'Вс.',
    'day_mon': 'Пн.',
    'day_tue': 'Вт.',
    'day_wed': 'Ср.',
    'day_thu': 'Чт.',
    'day_fri': 'Пт.',
    'day_sat': 'Сб.',
    'day_sunday': 'Воскресенье',
    'day_monday': 'Понедельник',
    'day_tuesday': 'Вторник',
    'day_wednesday': 'Среда',
    'day_thursday': 'Четверг',
    'day_friday': 'Пятница',
    'day_saturday': 'Суббота',
    'loading': 'Загрузка...',
    'calendar_day': 'День',
    'calendar_week': 'Неделя',
    'calendar_month': 'Месяц',
    'calendar_year': 'Год',
    'calendar_today': 'Сегодня',
    'month_january': 'Январь',
    'month_february': 'Февраль',
    'month_march': 'Март',
    'month_april': 'Апрель',
    'month_may': 'Май',
    'month_june': 'Июнь',
    'month_july': 'Июль',
    'month_august': 'Август',
    'month_september': 'Сентябрь',
    'month_october': 'Октябрь',
    'month_november': 'Ноябрь',
    'month_december': 'Декабрь',
    'month_jan': 'Янв',
    'month_feb': 'Фев',
    'month_mar': 'Мар',
    'month_apr': 'Апр',
    'month_may_short': 'Май',
    'month_jun': 'Июн',
    'month_jul': 'Июл',
    'month_aug': 'Авг',
    'month_sep': 'Сен',
    'month_oct': 'Окт',
    'month_nov': 'Ноя',
    'month_dec': 'Дек',
    'schedule_no_sessions_found': 'Сессии не найдены',
    'schedule_no_sessions_match_search': 'Ни одна сессия не соответствует вашему поиску',
    'session_upload': 'Загрузить',
    'session_wait': 'Ждите...',
    'session_watch': 'Смотреть',
    'session_error': 'Ошибка',
    'session_status_upcoming': 'Предстоящая',
    'session_status_finished': 'Завершена',
    'session_status_cancelled': 'Отменена',
    'session_processing': 'Обработка...',
    'session_with': 'Сессия с',
    'view_profile': 'Просмотреть профиль',
    'transcription_of_session': 'Расшифровка сессии',
    'minimize': 'Свернуть',
    'most_used_words': 'Наиболее используемые слова',
    'session_statistics': 'статистика сессии',
    'most_common_word': 'Наиболее часто используемое слово',
    'used': 'использовано',
    'times': 'раз',
    'during_all_sessions': 'за все сессии',
    'used_word_today_first_time': 'использовал это слово сегодня впервые',
    'word_appeared_in_speech': 'слово "[word]" появилось в речи клиента во время [session] сессии',
    'word_appeared_in_sessions': '"[word]" встречается в [count] сессиях',
    'highlights_previous_session': 'Основные моменты предыдущей сессии',
    'recommendations_upcoming_session': 'Рекомендации к предстоящей сессии:',
    'add_task': 'Добавить задачу',
    'plan_new_session': 'Запланировать новую сессию',
    'open_previous_statistic': 'Открыть предыдущую статистику',
    'fear_public_speaking': 'Страх предстоящего публичного выступления',
    'doubts_attractiveness': 'Сомнения в своей привлекательности',
    'panic_attacks': 'Панические атаки',
    'breathing_exercises': 'Дыхательные упражнения',
    'appointment_psychiatrist': 'Записаться на прием к психиатру',
    'calming_scheme': 'Схема успокоения перед публичным выступлением',
    'meetingPage_todays_speed': 'Скорость сегодня',
    'meetingPage_session_statistics': 'статистика сессии',
    'meetingPage_graphicSpeed_title': 'Громкая речь',
    'meetingPage_graphicSpeed_text': '[name] говорил(а) на [percent]% громче обычного сегодня',
    'meetingPage_taciturnity_title': 'Молчаливость',
    'meetingPage_taciturnity_text': '[name] молчал(а) [percent]% времени сессии сегодня',
    'meetingPage_graphicSpeed_bottom_a': 'средняя скорость',
    'meetingPage_graphicSpeed_bottom_b': 'слов в минуту',
    'meetingPage_todays_average_speed': 'Средняя скорость сегодня',
    'meetingPage_words_per_minute': 'слов в минуту',
    'meetingPage_volume_title': 'Анализ громкости',
    'meetingPage_volume_subtitle': 'Уровни громкости сессий во времени',
    'meetingPage_volume_average': 'Средняя громкость',
    'meetingPage_average_speed_title': 'Средняя скорость',
    'meetingPage_average_speed_subtitle': 'Скорость речи по сессиям',
    'meetingPage_average_speed_bottom': 'слов в минуту',
    'common_at': 'в',
    'task_assigned_to_session': 'Привязано к сессии',
    'session_no_description': 'Нет описания для этой сессии',
    'debug_analyze_session': 'Анализировать сессию',
    'debug_watch_video': 'Смотреть видео',
    'debug_add_task': 'Добавить задачу',
    'debug_chat': 'Чат',

    // Session creation
    'session_new_session': 'Новая сессия',
    'session_edit_session': 'Редактировать сессию',
    'session_add_title': 'Добавить заголовок',
    'session_select_date': 'Выберите дату сессии',
    'session_start_time': 'Время начала',
    'session_end_time': 'Время окончания',
    'session_add_task': 'Добавить задачу',
    'session_add_description': 'Добавить описание или вложение',
    'session_save_draft': 'Сохранить черновик',
    'session_delete': 'Удалить',
    'session_save': 'Сохранить',
    'session_create': 'Создать',

    // Repeat options
    'repeat_every': 'Повторять каждые: ',
    'repeat_interval': 'Интервал повторения: ',
    'repeat_dont_repeat': 'Не повторять',
    'repeat_everyday': 'каждый день',
    'repeat_every_other_day': 'через день',
    'repeat_every_week': 'каждую неделю',
    'repeat_every_two_weeks': 'каждые две недели',
    'repeat_every_month': 'каждый месяц',
    'repeat_custom': 'настроить',
    'repeat_number_of_sessions': 'Количество сессий: ',
    'repeat_number_of_events': 'Количество событий: ',
    'repeat_sessions_label': 'повторить: ',

    // Calendar event form
    'calendar_event_start_time': 'время начала',
    'calendar_event_end_time': 'время окончания',
    'calendar_event_text': 'текст события',
    'calendar_event_delete_all': 'Удалить все',
    'calendar_event_save_all': 'Обновить это и следующие',
    'calendar_event_event': 'Событие',
    'calendar_event_task': 'Задача',
    'calendar_event_session': 'Сессия',
    'calendar_new_event': 'Новое событие',
    'calendar_new_task': 'Новая задача',
    'calendar_new_session': 'Новая сессия',
    'calendar_edit_event': 'Редактировать событие',
    'calendar_edit_task': 'Редактировать задачу',
    'calendar_edit_session': 'Редактировать сессию',

    // Validation messages
    'validation_enter_date': 'Введите дату',
    'validation_enter_start_time': 'Введите время начала',
    'validation_enter_end_time': 'Введите время окончания',

    // Analysis folder management
    'analysis_create_new_folder': 'Создать новую папку',
    'analysis_add_file': 'Добавить файл',

    // Load more functionality
    'load_more': 'Загрузить еще',
    'no_more_sessions': 'Больше сессий для загрузки нет',

    // Subtitles context menu
    'subtitles_context_edit': 'Редактировать',
    'subtitles_context_comment': 'Комментарий',
    'subtitles_context_send_to': 'Отправить в...',
    'subtitles_context_folder': 'Папку',
    'subtitles_context_desktop': 'Рабочий стол',
    'subtitles_context_add_tag': 'Добавить тег',
    'subtitles_context_assign': 'Назначить...',
    'subtitles_context_red_flag': 'Красный флаг',
    'subtitles_context_attention': 'Внимание',
    'subtitles_context_edit_fast_actions': 'Изменить быстрые действия',

    // Comment popup
    'subtitles_comment_add': 'Добавить комментарий',
    'subtitles_comment_close': 'Закрыть',
    'subtitles_comment_done': 'Готово',

    // Send to desktop functionality
    'subtitles_select_text_to_send': 'Пожалуйста, выберите текст для отправки на рабочий стол',
    'subtitles_no_text_selected': 'Текст не выбран',
    'subtitles_quote_from_meeting': 'Цитата из встречи',
    'subtitles_meeting_quote_tag': 'Цитата встречи',
    'subtitles_selected_text_title': 'Выбранный текст из встречи',
    'subtitles_text_saved_success': 'Текст успешно сохранен на рабочий стол!',
    'subtitles_save_failed': 'Не удалось сохранить текст на рабочий стол. Попробуйте еще раз.',

    // Send to folder functionality
    'send_folder_client_tag': 'Клиент',
    'send_folder_quote_title': 'Цитата из сессии: ',
    'send_folder_preview': 'Предварительный просмотр',
    'send_folder_action_text': 'Заметка, которую вы добавили из',
    'send_folder_session_suffix': 'сессии',
    'send_folder_send_to_selected': 'Отправить в выбранный файл',
    'send_folder_create_and_send': 'Создать файл и отправить',
    'send_folder_default_filename': 'файл.анализ',

    // Meeting page error messages
    'meeting_auth_error': 'Произошла ошибка аутентификации',
    'meeting_invalid_response': 'Неверный формат ответа от сервера',
    'meeting_processing_error': 'Ошибка обработки ответа сервера',
    'meeting_network_error': 'Произошла сетевая ошибка при удалении слова',
    'meeting_default_name': 'Они',

    // Tasks
    'tasks_title': 'Задачи',
    'tasks_add': 'Добавить задачу',
    'tasks_add_new': 'Добавить новую задачу',
    'tasks_new_task': 'Новая задача',
    'tasks_edit': 'Редактировать задачу',
    'tasks_all_tags': 'Все метки',
    'tasks_empty': 'Нет задач. Нажмите "Добавить задачу" чтобы создать.',
    'tasks_load_error': 'Не удалось загрузить задачи',
    'tasks_save_error': 'Не удалось сохранить задачу',
    'tasks_delete_error': 'Не удалось удалить задачу',
    'tasks_confirm_delete': 'Удалить эту задачу?',
    'tasks_title_required': 'Пожалуйста, введите название задачи',
    'tasks_field_title': 'Название',
    'tasks_field_datetime': 'Дата и время',
    'tasks_field_tags': 'Метки',
    'tasks_has_date': 'Запланировать на определённую дату/время',
    'tasks_title_placeholder': 'Введите название задачи...',
    'tasks_tag_placeholder': 'Добавить метку...',
    'tasks_field_description': 'Описание',
    'tasks_description_placeholder': 'Добавьте детали о задаче...',
    'tasks_datetime_label': 'Дата и время',
    'tasks_assign_to_session': 'Назначить на сессию',
    'tasks_session_none': 'Нет',
    'tasks_session_untitled': 'Сессия без названия',
    'tasks_no_future_sessions': 'Нет будущих сессий',
    
    // Analysis
    'analysis_title': 'Анализ',
    'analysis_add_folder': 'Добавить новую папку',
    'analysis_new_folder': 'Новая папка',
    'analysis_confirm_delete': 'Удалить',
    'analysis_select_client': 'Выберите клиента для просмотра анализа',
    'analysis_filter_client': 'Показать только файлы этого клиента',
    'analysis_empty_folder': 'Нет файлов или папок',

    // Заметки
    'notes_title': 'Заметки',
    'notes_add': 'Добавить заметку',
    'notes_add_new': 'Добавить новую заметку',
    'notes_new_title': 'Новая заметка',
    'notes_remove': 'Удалить',
    'notes_save': 'Сохранить заметку',
    'notes_empty': 'Заметок пока нет. Нажмите "Добавить заметку", чтобы создать.',
    'notes_select_or_create': 'Выберите заметку или создайте новую',
    'notes_confirm_delete': 'Удалить эту заметку?',
    'notes_load_error': 'Не удалось загрузить заметки',
    'notes_save_error': 'Не удалось сохранить заметку',
    'notes_delete_error': 'Не удалось удалить заметку',
    'notes_deleted_success': 'Заметка успешно удалена',
    'notes_bound_to_client': 'Привязать к клиенту',
    'tasks_bound_to_client': 'Привязать к клиенту',

    // Filter tooltips
    'filter_show_all_notes': 'Показать все заметки',
    'filter_show_client_notes': 'Показать только заметки клиента {name}',
    'filter_show_all_tasks': 'Показать все задачи',
    'filter_show_client_tasks': 'Показать только задачи клиента {name}',
    'filter_show_all_files': 'Показать все файлы',
    'filter_show_client_files': 'Показать только файлы клиента {name}',

    // Goals
    'goals_title': 'Цели',
    'goals_add': 'Добавить цель',
    'goals_edit': 'Редактировать цель',
    'goals_empty': 'Нет целей. Нажмите "Добавить цель", чтобы создать.',
    'goals_select_client': 'Выберите клиента для просмотра целей',
    'goals_field_emoji': 'Эмодзи',
    'goals_field_title': 'Название цели',
    'goals_field_start_date': 'Дата начала',
    'goals_select_emoji': 'Выберите эмодзи',
    'goals_title_placeholder': 'например, дни без курения',
    'goals_title_required': 'Пожалуйста, введите название цели',
    'goals_confirm_delete': 'Удалить эту цель?',
    'goals_confirm_reset': 'Сбросить эту цель до дня 0?',
    'goals_reset': 'Сбросить до дня 0',
    'goals_delete': 'Удалить цель',
    'goals_click_to_edit_days': 'Нажмите, чтобы изменить дни',
    'goals_load_error': 'Не удалось загрузить цели',
    'goals_save_error': 'Не удалось сохранить цель',
    'goals_delete_error': 'Не удалось удалить цель',
    'goals_reset_error': 'Не удалось сбросить цель',
    'goals_update_error': 'Не удалось обновить цель',
    'goals_add_new': 'Добавить новую цель',

    // Bottom menu
    'bottomMenu_Tasks': 'Задачи',

    // Statistics page
    'statistic_title': 'Статистика',
    'statistic_select_client': 'Выберите клиента для просмотра статистики',
    'statistic_all_time': 'Все время',
    'statistic_month': 'Месяц',
    'statistic_week': 'Неделя',
    'statistic_custom': 'Свой диапазон',
    'statistic_most_used_words': 'Наиболее используемые слова',
    'statistic_no_data': 'Нет данных',
    'statistic_average_speed': 'Средняя скорость речи',
    'statistic_speed_subtitle': 'По всем сессиям',
    'statistic_avg_speed_label': 'Средняя скорость',
    'statistic_volume': 'Громкость речи',
    'statistic_volume_subtitle': 'Уровень громкости по сессиям',
    'statistic_avg_volume': 'Средняя громкость',
    'statistic_silence': 'Молчаливость',
    'statistic_silence_label': 'Средний процент молчания',
    'statistic_session': 'Сессия',

    'connection_lost': 'Соединение потеряно',
    'connection_lost_message': 'Возникли проблемы с подключением к серверу. Проверьте интернет-соединение.',
    'connection_retry_in': 'Повторная попытка через',
    'connection_retrying': 'Подключение...',
    'connection_retry_now': 'Попробовать сейчас',
};